import React from 'react';
//import Modal from '@mui/material/Modal';
//import Button from '@mui/material/Button';
import WarningIcon from '@mui/icons-material/Warning';
//import {Tools} from './Tools';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import useStyles from './Styles';

interface ProglemsProps {
    names: string[],
    yes():void,
    no():void,
    isOpen:boolean,
	labels?:string[],
	force?:boolean,
}

const Proglems = (props:ProglemsProps)=> {
    const classes = useStyles();

	const labels:string[] = ['登録する','修正する'];
	if( props.labels ){
		labels[0] = props.labels[0];
		labels[1] = props.labels[1];
	}

	let force = false;
	if( props.force ){
		force = props.force;
	}

	if(!props.isOpen){
		return (null);
	}

    return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.no();
				}
			}}
		>
			<DialogTitle color='primary'>登録内容の確認</DialogTitle>
			<DialogContent>
				<div style={{marginBottom:"1em"}}>
					<WarningIcon style={{verticalAlign:'middle',marginRight:'0.25em',color:'orange'}}/>以下の項目がよろしくありません。
				</div>
				<div style={{marginBottom:"1em",border:'1px solid silver',padding:'1em',width:'100%',boxSizing:'border-box'}}>
					<ul style={{margin:'0',padding:'0',listStyle:'none'}}>
					{props.names.map((name:string,index:number)=>{
						const key = "name"+index;
						return (
							<li key={key} style={{margin:'0',padding:'0',color:'red',lineHeight:'1.5em'}}>・{name}</li>
						)
					})}
					</ul>
				</div>
				{force &&
				<div style={{marginBottom:"2em",fontSize:'90%',color:'#444444'}}>
					このまま登録することも可能ですが、正しく登録されない可能性があります。
				</div>
				}
				<div style={{marginBottom:"2em",fontSize:'80%',color:'#444444'}}>
					※入力内容に間違いがないのにこの警告が表示されてしまう場合は架空ストアにご一報を。可能でしたらこの画面のスクリーンショットもお送り下さい。
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{force ? (
				<BottomButtons button1={labels[0]} onClick1={props.yes} button2={labels[1]} onClick2={props.no} bottom={0}/>
				):(
				<BottomButtons button1={labels[1]} onClick1={props.no} bottom={0}/>
				)}
			</DialogActions>
		</Dialog>
    );
}

export default Proglems;
